import React from 'react';
import '../styles/EventBanner.css';

const EventBanner = () => {
  return (
    <div className="event-banner">
      <div className="banner-content">
<div className="banner-links">
          <a href="https://drive.google.com/file/d/1HwZtP4e_15ss8OHVNrsz2e0UGWcd7Gf7/view?usp=drive_link" className="banner-link" target="_blank" rel="noopener noreferrer">• View Schedule •</a> 
        </div>
        <div className="banner-lunch">
          🍽️ Lunch will be provided to all participants on both the days
        </div>
      </div>
    </div>
  );
};

export default EventBanner;
